import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams
} from 'react-router-dom';

import { AuthProvider } from './hooks/useAuth';
import Navbar from './components/Navbar';
import PlexoNatural from './components/PlexoNatural';
import PublicProfile from './components/PublicProfile';
import LiveSession from './components/LiveSession';
import ResponsiveContainer from './components/ResponsiveContainer';
import ProofDecoder from './components/ProofDecoder';
import ExistencePlexo from './components/ExistencePlexo';
import OAuthXCallback from './components/OAuthXCallback';
import About from './components/About';
import PerformanceArtTest from './components/PerformanceArtTest';
import './app.css';

// Wrapper para página inicial
const ResponsivePlexoNatural = () => (
  <ResponsiveContainer>
    <PlexoNatural />
  </ResponsiveContainer>
);

// Perfil direto pela raiz: /ismaeltrabuco
const UsernameProfile = () => {
  const { username } = useParams();
  return <PublicProfile />;
};

// Redireciona antigo → novo (compatibilidade)
const LegacyProfileRedirect = () => {
  const { username } = useParams();
  return <Navigate to={`/${username}`} replace />;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <div className="pt-16">
          <Routes>
            {/* Página inicial */}
            <Route path="/" element={<ResponsivePlexoNatural />} />

            {/* URL LIMPA E ETERNA — PRIORIDADE #1 */}
            <Route path="/:username" element={<UsernameProfile />} />

            {/* Compatibilidade com links antigos */}
            <Route path="/perfil/username/:username" element={<LegacyProfileRedirect />} />
            <Route path="/perfil/:userId" element={<PublicProfile />} />

            {/* Páginas normais */}
            <Route path="/decoder" element={<ProofDecoder />} />
            <Route path="/existence-plexo" element={<ExistencePlexo />} />
            <Route path="/oauth/x/callback" element={<OAuthXCallback />} />
            <Route path="/live" element={<LiveSession />} />
            <Route path="/performance-test" element={<PerformanceArtTest />} />
            <Route path="/about" element={<About />} />

            {/* 404 */}
            <Route path="*" element={
              <div className="text-white text-center pt-32 text-4xl font-bold">
                404 — Página não encontrada
              </div>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;

